module.exports = __webpack_public_path__ + "img/payment.9402f1ff.svg";